module.exports = __webpack_public_path__ + "img/14.55dc8950.gif";